import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import '../../assets/css/legacyCMSStyles.css';

import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';



// Engage Actions 
import { getAllCLCommunities, getCLCommunityById } from '../../actions/communityActions';
import { LogoutProccess } from '../../actions/authActions';
import LegacyAppBar from '../ui/LegacyAppBar';

//Views
import MessagingList from './MessagingList';


const TabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}>
            {value === index && (
                <Box p={3}>
                    <Grid>{children}</Grid>
                </Box>
            )}
        </div>
    );
};

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

export class MessagingBase extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            actualCommunityId: undefined,
            //Device details
            openDeviceDetails: false,
            deviceSelectedForDetails: {},
            selectedDevices: [],
            //tabs
            tabSelected: 0,//TODO return to 0
            //Community
            superUserCommunitySelected: undefined,
            superUserActivitiesLoaddedForCommunity: undefined,
            //superUserCombo
            openCommunityCombo: false
        }

    };

    componentDidUpdate() {

        if (this.props.communityData || (this.props.communityData && this.props.communityData.length > 0)) {
            const communitySelected = this.props.communityData.find(community => community.communityId === localStorage.getItem('communityId'));

            if (this.state.superUserCommunitySelected !== undefined && this.state.superUserCommunitySelected.communityId === communitySelected.communityId)
                return

            if (communitySelected !== undefined && this.state.superUserCommunitySelected === undefined) {
                this.setState({ superUserCommunitySelected: communitySelected });
            }
        }
    }

    componentDidMount() {

        if (!this.props.communityData || (this.props.communityData && this.props.communityData.length === 0)) {
            this.GetAllCommunities();
        }
    }


    //#region methods

    a11yProps = (index) => {
        return {
            id: `boards-tab-${index}`,
            'aria-controls': `boards-tabpanel-${index}`,
        };
    };

    handleCommunityChange = () => {
        const id = localStorage.getItem('communityId');
        const communitySelected = this.props.communityData.find(community => community.communityId === localStorage.getItem('communityId'));
        this.setState({ communityId: id, superUserCommunitySelected: communitySelected });
    }

    GetAllCommunities = () => {
        if (localStorage.getItem('superAdmin') === "false")
            this.props.getCLCommunityById(localStorage.getItem('communityId'))
        else
            this.props.getAllCLCommunities()
    };

    logout = () => {
        this.props.LogoutProccess();
    }


    handleCommunityCombo = () => {
        this.setState((prevState) => ({ openCommunityCombo: !prevState.openCommunityCombo }));
    }

    handleCommunityOnBlur = () => {
        this.setState({ openCommunityCombo: false })
    }

    setLocalState = (objectToSet) => {
        try {
            this.setState({ ...objectToSet });
        } catch (err) { }
    };

    handlerMessage = () => {
        var link = document.getElementById('Message_Btn')
        link.click()
    };


    deviceSelectedHandler = (openDeviceDetails, deviceSelectedForDetails) => {
        this.setState({ openDeviceDetails: openDeviceDetails, deviceSelectedForDetails: deviceSelectedForDetails });
    }

    closeDetails = () => {
        try {
            this.setState({ openDeviceDetails: false, deviceSelectedForDetails: undefined, selectedDevices: [] })
        } catch (err) {
            return undefined;
        }
    }

    handleIsSelectedDevices = (selectedDevices = []) => {
        this.setState({ selectedDevices: selectedDevices });
    }


    //#endregion Methods

    //#region Components

    eHubTabComponent = () => {

        return (
            <Grid item container alignContent='flex-start'>
                <Grid item container alignContent='flex-end'>
                    <Grid item container>
                    </Grid>
                </Grid>
                <Grid item container style={{ height: '90%' }}>
                    <this.TabsContent />
                </Grid>
            </Grid>
        )
    }

    TabsContent = () => {

        return (
            <Grid item container className="LTabContentContainer" >
                <MessagingList
                    communityInfo={this.state.superUserCommunitySelected ? this.state.superUserCommunitySelected : undefined}
                    isSelectedDevices={(selectedDevices) => this.handleIsSelectedDevices(selectedDevices)}
                />
            </Grid>
        )
    }

    //#endregion

    render() {

        return (
            <Grid item container className={this.state.openDeviceDetails ? 'LGeneralBackgroundWhite' : 'LGeneralBackground'}>
                <Grid item container style={{ height: '20vh' }}>
                    <LegacyAppBar
                        dispatchActions={this.handleCommunityChange}
                        superUserVisible={localStorage.getItem('superAdmin') === "true" && !this.state.openDeviceDetails ? true : false}
                        title={'TV Messaging'}
                    />
                    <Grid item container className='LHeadersButtons' style={{ paddingLeft: '20px' }}>
                        <Grid item
                            id='Messaging_Btn'
                            className={ this.state.selectedDevices.length > 0 ? "appbtnBarButtonv2 LButtonStyle LBlueGrayButton" : "appbtnBarButtonv2 LButtonStyle LBlueGrayButton disabledSkybluebtn-engage"}
                            onClick={this.handlerMessage}>
                            Message
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item container style={{ minHeight: '80vh' }}>
                    <this.eHubTabComponent />
                </Grid>
            </Grid>
        )
    }
}


function mapStateToProps(state, dispatch) {
    const isSuperAdmin = (state.authReducer && state.authReducer.superAdmin) ? state.authReducer.superAdmin : undefined;
    const givenName = (state.authReducer && state.authReducer.givenName) ? state.authReducer.givenName : undefined;
    const familyName = (state.authReducer && state.authReducer.familyName) ? state.authReducer.familyName : undefined;
    let communityData = (state.communityReducer && state.communityReducer.communityData && Array.isArray(state.communityReducer.communityData) && state.communityReducer.communityData.length > 0) ?
        state.communityReducer.communityData.map(item => (
            {
                _id: item._id,
                name: item.communityName,
                communityId: item.communityId,
                address: item.communityAddress + ', ' + item.communityCity + ', ' + item.communityState + ' ' + item.communityZipcode,
                logo: item.communityLogoUrl,
                logsRecipient: item.logsRecipient,
                isVoiceAvailable: item.isVoiceAvailable,
                entertain360: item.entertain360,
                coroHealth: item.coroHealth,
                worxHub: item.worxHub,
                tels: item.tels,
            }
        )) : [];

    if (communityData) {
        communityData =
            communityData.map((item, index) => {
                item.indexForCombo = index;
                return item;
            })
    }

    return {
        isSuperAdmin: isSuperAdmin,
        givenName: givenName,
        familyName: familyName,
        communityData: communityData,
        isCommunitySuccess: state.communityReducer,
        deviceReducerType: (state.deviceReducer && state.deviceReducer.type) ? state.deviceReducer.type : ""
    }
};

export default connect(mapStateToProps, { getAllCLCommunities, getCLCommunityById, LogoutProccess })(MessagingBase)